import React, { Component } from 'react';

import { getClient } from '../data/serviceClients';

// helper UI actions and functions
import LeftColumn from './components/ClientExplorer/Explorer';
import RightColumn from './components/ClientProfile/Profile';

class ClientTool extends Component {
	constructor(props) {
		super(props);
		// console.log(props);
		this.state = {
			currentClient: null,
		}
		this.loadClient = this.loadClient.bind(this);
		this.updateClient = this.updateClient.bind(this);
		this.resetProfile = this.resetProfile.bind(this);
	}

// get Client
	loadClient(clientCode) {
		// console.log("fetching "+clientCode);
		var listOption = document.querySelectorAll("#client .result-list li.cc-"+clientCode)[0];
		if (listOption) {
			listOption.classList.add("hover");
		}

		getClient(clientCode).then(client => {
			
			if (client.clientCode === "fliq") {
				client.sites = client.sites.filter(site => site.instance === "prod" && site.siteCode === "flbl");
			
			} else {
				client.sites = client.sites.filter(site => site.instance === "prod" && site.siteCode === "www");
			}
			// console.log(client);
			this.setState({
				currentClient: client,
			});
			document.querySelectorAll("#client .profile")[0].style.display = "block";
			// getTransactions(clientCode).then(transactions => {
			// 	console.log(transactions);
				
			// 	if (transactions.length) {
			// 		client["transactions"] = transactions[0];
			// 	} else {
			// 		client["transactions"] = [];
			// 	}
			// });
		});
	}

// close client
	resetProfile() {
		// console.log("clear current client")
		Array.from(document.querySelectorAll('#client .result-list li')).forEach((el) => el.classList.remove('hover'));

		this.setState({
			currentClient: null,
		});
	}
// update client State
	updateClient(key, value, subArr) {
		// console.log(key, value);
		if (value === "Select..." || value === "null") {
			value = null;
		}
		if (key === "altProductClientCode" && value === "null") {
			value = null;
		}
		if (subArr) {
			if (subArr === "sites") {
				this.setState(state => {
					state.currentClient[subArr][0][key] = value;
					return state;
				});
			} else {
				this.setState(state => {
					state.currentClient[subArr][key] = value;
					return state;
				});
			}
		} else {
			this.setState(state => {
				state.currentClient[key] = value;
				return state;
			});
		}
		// console.log(this.state);
	}

	render() {
		const { error, currentClient } = this.state;
		const loadClients = this.props.loadClients;
		const clients = this.props.clients;

		if (error) {
			return <p>{error.message}</p>;
		}

		return (
			<div className="columns">
				<LeftColumn
					clients={clients}
					loadClients={loadClients}
					getClient={this.loadClient}
					resetProfile={this.resetProfile}
				/>
				<RightColumn
					clients={clients}
					currentClient={currentClient}
					resetProfile={this.resetProfile}
					getClient={this.loadClient}
					updateClient={this.updateClient}
				/>
			</div>
		)
	}
}

export default ClientTool;


// WEBPACK FOOTER //
// ./src/component_client/ClientTool.js